<template>
  <b-card aria-label="Résultats de génération de factures">
    <div
      v-if="isLoading"
      class="text-center mb-2"
    >
      <b-spinner
        variant="primary"
        label="Chargement"
      />
    </div>

    <div v-else>
      <h4 class="mb-3">
        Factures Générées
      </h4>

      <!-- Success Summary -->
      <b-alert
        v-if="results.invoices && results.invoices.length > 0"
        show
        variant="success"
        class="mb-3"
      >
        <feather-icon
          icon="CheckCircleIcon"
          class="mr-1"
        />
        {{ results.invoices.length }} facture{{ results.invoices.length > 1 ? 's' : '' }} créée{{ results.invoices.length > 1 ? 's' : '' }} avec succès
      </b-alert>

      <!-- Error Summary -->
      <b-alert
        v-if="results.errors && results.errors.length > 0"
        show
        variant="warning"
        class="mb-3"
      >
        <feather-icon
          icon="AlertTriangleIcon"
          class="mr-1"
        />
        {{ results.errors.length }} erreur{{ results.errors.length > 1 ? 's' : '' }}
      </b-alert>

      <!-- Success List -->
      <div
        v-if="results.invoices && results.invoices.length > 0"
        class="mb-4"
      >
        <h5 class="mb-2">
          Factures créées
        </h5>
        <b-list-group>
          <b-list-group-item
            v-for="invoice in results.invoices"
            :key="invoice.invoice_id"
            class="d-flex justify-content-between align-items-center"
          >
            <div>
              <strong>{{ invoice.supplier_name }}</strong>
              <br>
              <small class="text-muted">
                Facture #{{ invoice.invoice_id }} • {{ invoice.nb_orders }} commande{{ invoice.nb_orders > 1 ? 's' : '' }} • {{ formatCurrency(invoice.total_ttc) }}
              </small>
            </div>
            <div class="d-flex gap-2">
              <b-button
                variant="outline-primary"
                size="sm"
                @click="viewInvoice(invoice.invoice_id)"
              >
                <feather-icon
                  icon="EyeIcon"
                  size="14"
                />
                Voir
              </b-button>
              <b-button
                variant="outline-success"
                size="sm"
                @click="printInvoice(invoice.invoice_id)"
              >
                <feather-icon
                  icon="PrinterIcon"
                  size="14"
                />
                Imprimer
              </b-button>
            </div>
          </b-list-group-item>
        </b-list-group>
      </div>

      <!-- Error List -->
      <div
        v-if="results.errors && results.errors.length > 0"
        class="mb-4"
      >
        <h5 class="mb-2">
          Erreurs
        </h5>
        <b-list-group>
          <b-list-group-item
            v-for="(error, index) in results.errors"
            :key="index"
            variant="warning"
          >
            <strong>{{ error.supplier_name }}</strong>
            <br>
            <small>{{ error.error }}</small>
          </b-list-group-item>
        </b-list-group>
      </div>

      <!-- Actions -->
      <div class="d-flex justify-content-between mt-4">
        <b-button
          variant="outline-secondary"
          @click="goBack"
        >
          <feather-icon
            icon="ArrowLeftIcon"
            class="mr-1"
          />
          Retour
        </b-button>
      </div>
    </div>
  </b-card>
</template>

<script>
import {
  BCard, BAlert, BListGroup, BListGroupItem, BButton, BSpinner,
} from 'bootstrap-vue'

export default {
  name: 'BatchInvoices',
  components: {
    BCard,
    BAlert,
    BListGroup,
    BListGroupItem,
    BButton,
    BSpinner,
  },
  data() {
    return {
      results: {
        invoices: [],
        errors: [],
      },
      isLoading: false,
    }
  },
  created() {
    this.loadResults()
  },
  methods: {
    loadResults() {
      const storedResults = sessionStorage.getItem('batchInvoiceResults')
      if (storedResults) {
        this.results = JSON.parse(storedResults)
        // Clear from session storage
        sessionStorage.removeItem('batchInvoiceResults')
      } else {
        // No results found, redirect back
        this.$router.push({ name: 'invoice-create' })
      }
    },

    formatCurrency(amount) {
      return new Intl.NumberFormat('fr-TN', {
        style: 'currency',
        currency: 'TND',
      }).format(amount)
    },

    viewInvoice(invoiceId) {
      this.$router.push({ name: 'invoice-show', params: { id: invoiceId } })
    },

    printInvoice(invoiceId) {
      // Open invoice in new tab for printing
      const url = `${window.location.origin}/invoices/show/${invoiceId}`
      window.open(url, '_blank')
    },

    goBack() {
      this.$router.push({ name: 'invoice-add' })
    },
  },
}
</script>

<style lang="scss" scoped>
.gap-2 {
  gap: 0.5rem;
}
</style>
